import { CreateSlice } from './index'

export type NoturnoPreviewState = {
    /** Índice da config noturno selecionada na prévia da TabelaHorario. */
    noturnoIdx: number
    setNoturnoIdx: (idx: number) => void
}

export const createNoturnoPreviewSlice: CreateSlice<
    NoturnoPreviewState
> = set => ({
    noturnoIdx: 0,
    setNoturnoIdx: idx => set({ noturnoIdx: idx }),
})
